export default __webpack_public_path__ + "static/media/icn-search.a5ce9c2f.svg";